import { useParams } from 'react-router-dom'
import Container from '@mui/material/Container'

import { useQuery } from '~/client/hooks/cqrpc'
import Loading from '~/client/components/Loading'
import NotFound from '~/client/components/NotFound'
import Heading from '~/client/components/Heading'
import TabsLayout from '~/client/components/TabsLayout'

export default function Layout(){
  const { documentId } = useParams()
  const documentQuery = useQuery('documents.getById', { id: documentId })
  if (!documentQuery.result)
    return documentQuery.loading ? <Loading /> : <NotFound/>
  return <>
    <Container sx={{mt: 2}}>
      <Heading>{documentQuery.result.name}</Heading>
    </Container>
    <TabsLayout
      context={{
        documentId, document: documentQuery.result, documentQuery
      }}
      tabs={[
        {
          label: 'Edit',
          path: `/data/${documentId}/`,
        },
        {
          label: 'Sharing',
          path: `/data/${documentId}/sharing`,
        },
        {
          label: 'History',
          path: `/data/${documentId}/history`,
        },
      ]}
    />
  </>
}
